'use client';

import * as React from 'react';

export type UseEntitlementConfirmationOptions = {
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export function useEntitlementConfirmation({
  defaultOpen = false,
  onOpenChange,
}: UseEntitlementConfirmationOptions = {}) {
  const [isOpen, setIsOpen] = React.useState<boolean>(defaultOpen);

  const close = React.useCallback(() => {
    setIsOpen(false);
    onOpenChange?.(false);
  }, [onOpenChange]);

  const open = React.useCallback(() => {
    setIsOpen(true);
    onOpenChange?.(true);
  }, [onOpenChange]);

  React.useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, close]);

  return { isOpen, open, close };
}
